import React, { createContext, useState, useContext, useMemo, useEffect } from 'react';

const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
  const [sessionId, setSessionId] = useState(null);

  // Effect to manage sessionId persistence
  useEffect(() => {
    // Check if window is defined (Gatsby specific check for SSR vs Client)
    if (typeof window !== 'undefined') {
      let storedSessionId = sessionStorage.getItem('sessionId');
      if (storedSessionId) {
        setSessionId(storedSessionId);
      } else {
        // Generate a unique ID (use crypto.randomUUID if available, otherwise fallback)
        const newSessionId = window.crypto?.randomUUID 
          ? window.crypto.randomUUID() 
          : `session_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`;
        sessionStorage.setItem('sessionId', newSessionId);
        setSessionId(newSessionId);
      }
    }
  }, []); // Empty dependency array ensures this runs only once on mount

  // Memoize the context value
  const value = useMemo(() => ({
    sessionId,
  }), [sessionId]);

  return (
    <SessionContext.Provider value={value}>
      {children}
    </SessionContext.Provider>
  );
};

// Custom hook to use the Session context
export const useSessionContext = () => {
  const context = useContext(SessionContext);
  if (context === undefined) {
    throw new Error('useSessionContext must be used within a SessionProvider');
  }
  return context;
}; 